<template>
    <div    class="bg-white">
        <div class="mx-auto py-12 px-4 max-w-screen-xl sm:px-6 lg:px-8 lg:py-24">
            <div class="space-y-12">
                <div class="sm:space-y-4 md:max-w-xl lg:max-w-3xl xl:max-w-none">
                    <h2 class="text-3xl pb-0 font-extrabold tracking-tight sm:text-4xl">Installation Images</h2>
                    <p class="text-xl pt-0 text-center text-gray-500">Meter installed on {{ installDate }}</p>
                </div>
                <ul class="space-y-12 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:grid-cols-3 lg:gap-x-8">
                    <li     v-for="(image, date) in installImages">
                        <div class="space-y-4">
                            <div class="relative pb-2/3">
                                <img    @click="openImage(image)"
                                        class="object-cover object-center h-full w-full shadow-lg rounded-lg" :src="image" alt="">
                            </div>
                        </div>
                    </li>
                </ul>

                <!-- Installation Images from Wizard on App -->
                <div class="sm:space-y-4 md:max-w-xl lg:max-w-3xl xl:max-w-none">
                    <h2 class="text-3xl pb-0 font-extrabold tracking-tight sm:text-4xl">App Installation Images</h2>
                    <p class="text-xl pt-0 text-center text-gray-500">Meter installed on {{ appInstallationDate }}</p>
                </div>
                <ul class="space-y-12 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:grid-cols-3 lg:gap-x-8">
                    <li     v-for="(image, date) in installImagesAppWizard">
                        <div class="space-y-4">
                            <div class="relative pb-2/3">
                                <img    :src="image"
                                        alt="" class="object-cover object-center h-full w-full shadow-lg rounded-lg" @click="openImage(image)">
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

    </div>
</template>

<script>

import {iconNamesMixin} from '@/mixins/IconNamesMixin';

export default {
    name: "InstallationImages",
    mixins: [iconNamesMixin],
    components: {},
    props: {
        installImages: [Object, Array],
        installDate: String,
        installImagesAppWizard: [Object, Array],
        appInstallationDate: String,
    },
    data() {
        return {

        }
    },
    created() {
        
    },
    mounted() {
        
    },
    methods: {
        openImage(image) {
            let urlPartial = `${image}`
            window.open(`${urlPartial}`, '_blank')
        },
    },
    computed: {
        
    },
    watch: {
        
    },
}
</script>

<style scoped>

</style>